var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect22, _rect23, _polygon8, _polygon9, _polygon10, _rect24, _polygon11, _rect25, _polygon12, _rect26, _rect27, _polygon13, _polygon14, _rect28, _rect29, _rect30, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _rect31, _rect32, _rect33, _rect34, _polygon20, _polygon21, _rect35, _rect36, _rect37, _polygon22, _polygon23, _polygon24, _rect38, _polygon25, _rect39, _polygon26, _rect40, _polygon27, _rect41, _rect42, _polygon28, _polygon29, _rect43, _rect44, _rect45, _polygon30, _polygon31, _polygon32, _rect46, _polygon33, _rect47, _polygon34, _rect48, _polygon35, _rect49, _rect50, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _rect51, _rect52, _rect53, _rect54, _rect55, _polygon46, _polygon47, _polygon48, _rect56, _rect57, _rect58, _rect59, _rect60, _polygon49, _polygon50, _polygon51, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _rect81, _rect82, _polygon59, _polygon60, _polygon61, _rect83, _polygon62, _rect84, _polygon63, _rect85, _rect86, _polygon64, _polygon65, _rect87, _rect88, _rect89, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _rect90, _rect91, _rect92, _rect93, _polygon71, _polygon72, _rect94, _rect95, _rect96, _polygon73, _polygon74, _polygon75, _rect97, _polygon76, _rect98, _polygon77, _rect99, _polygon78, _rect100, _rect101, _polygon79, _polygon80, _rect102, _rect103, _rect104, _polygon81, _polygon82, _polygon83, _rect105, _polygon84, _rect106, _polygon85, _rect107, _polygon86, _rect108, _rect109, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _rect110, _rect111, _rect112, _rect113, _rect114, _polygon97, _polygon98, _polygon99, _rect115, _rect116, _rect117, _rect118, _rect119, _polygon100, _polygon101, _polygon102, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _rect140, _rect141, _polygon110, _polygon111, _polygon112, _rect142, _polygon113, _rect143, _polygon114, _rect144, _rect145, _polygon115, _polygon116, _rect146, _rect147, _rect148, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _rect149, _rect150, _rect151, _rect152, _polygon122, _polygon123, _rect153, _rect154, _rect155, _polygon124, _polygon125, _polygon126, _rect156, _polygon127, _rect157, _polygon128, _rect158, _polygon129, _rect159, _rect160, _polygon130, _polygon131, _rect161, _rect162, _rect163, _polygon132, _polygon133, _polygon134, _rect164, _polygon135, _rect165, _polygon136, _rect166, _polygon137, _rect167, _rect168, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _rect169, _rect170, _rect171, _rect172, _rect173, _polygon148, _polygon149, _polygon150, _rect174, _rect175, _rect176, _rect177, _rect178, _polygon151, _polygon152, _polygon153, _rect179, _path, _path2, _path3, _path4, _path5, _circle, _rect180, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCyberSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1042.03903,
    height: 709.08851,
    viewBox: "0 0 1042.03903 709.08851",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hacker_mind") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 875,
    height: 470.67901,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158.17901,
    y: 66.35802,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 184.41358,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 198.30247,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198.30247,
    y: 100.30864,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 213.73457,
    y: 81.79012,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 213.73457,
    y: 101.85185,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 198.30247,
    y: 140.4321,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 213.73457,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 198.30247,
    y: 236.11111,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 184.41358,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 158.17901,
    y: 86.41975,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 158.17901,
    y: 279.32099,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 158.17901,
    y: 319.44444,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 158.17901,
    y: 339.50617,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 155.09259,
    y: 108.02469,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 196.75926,
    y: 126.54321,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 155.09259,
    y: 206.79012,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 155.09259,
    y: 223.76543,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 196.75926,
    y: 322.53086,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 184.41358,
    y: 359.5679,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "158.179 121.914 158.179 125 161.265 125 161.265 131.173 158.179 131.173 158.179 134.259 165.895 134.259 165.895 121.914 158.179 121.914",
    fill: "#6c63ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.414 100.309 184.414 103.395 187.5 103.395 187.5 109.568 184.414 109.568 184.414 112.654 192.13 112.654 192.13 100.309 184.414 100.309",
    fill: "#6c63ff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.735 120.37 213.735 123.457 216.821 123.457 216.821 129.63 213.735 129.63 213.735 132.716 221.451 132.716 221.451 120.37 213.735 120.37",
    fill: "#6c63ff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.735 180.556 213.735 183.642 216.821 183.642 216.821 189.815 213.735 189.815 213.735 192.901 221.451 192.901 221.451 180.556 213.735 180.556",
    fill: "#6c63ff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.735 200.617 213.735 203.704 216.821 203.704 216.821 209.877 213.735 209.877 213.735 212.963 221.451 212.963 221.451 200.617 213.735 200.617",
    fill: "#6c63ff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.735 138.889 213.735 141.975 216.821 141.975 216.821 148.148 213.735 148.148 213.735 151.235 221.451 151.235 221.451 138.889 213.735 138.889",
    fill: "#6c63ff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.302 81.79 198.302 84.877 201.389 84.877 201.389 91.049 198.302 91.049 198.302 94.136 206.019 94.136 206.019 81.79 198.302 81.79",
    fill: "#6c63ff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 198.30247,
    y: 180.55556,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 198.30247,
    y: 217.59259,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.302 199.074 198.302 202.16 201.389 202.16 201.389 208.333 198.302 208.333 198.302 211.42 206.019 211.42 206.019 199.074 198.302 199.074",
    fill: "#6c63ff"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.414 120.37 184.414 123.457 187.5 123.457 187.5 129.63 184.414 129.63 184.414 132.716 192.13 132.716 192.13 120.37 184.414 120.37",
    fill: "#6c63ff"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.414 140.432 184.414 143.519 187.5 143.519 187.5 149.691 184.414 149.691 184.414 152.778 192.13 152.778 192.13 140.432 184.414 140.432",
    fill: "#6c63ff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 184.41358,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.414 180.556 184.414 183.642 187.5 183.642 187.5 189.815 184.414 189.815 184.414 192.901 192.13 192.901 192.13 180.556 184.414 180.556",
    fill: "#6c63ff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 184.41358,
    y: 240.74074,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.414 220.679 184.414 223.765 187.5 223.765 187.5 229.938 184.414 229.938 184.414 233.025 192.13 233.025 192.13 220.679 184.414 220.679",
    fill: "#6c63ff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 184.41358,
    y: 280.8642,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 198.30247,
    y: 277.77778,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.414 260.802 184.414 263.889 187.5 263.889 187.5 270.062 184.414 270.062 184.414 273.148 192.13 273.148 192.13 260.802 184.414 260.802",
    fill: "#6c63ff"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.735 260.802 213.735 263.889 216.821 263.889 216.821 270.062 213.735 270.062 213.735 273.148 221.451 273.148 221.451 260.802 213.735 260.802",
    fill: "#6c63ff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 292.43827,
    y: 81.79012,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 292.43827,
    y: 101.85185,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 292.43827,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.438 120.37 292.438 123.457 295.525 123.457 295.525 129.63 292.438 129.63 292.438 132.716 300.154 132.716 300.154 120.37 292.438 120.37",
    fill: "#6c63ff"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.438 180.556 292.438 183.642 295.525 183.642 295.525 189.815 292.438 189.815 292.438 192.901 300.154 192.901 300.154 180.556 292.438 180.556",
    fill: "#6c63ff"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.438 200.617 292.438 203.704 295.525 203.704 295.525 209.877 292.438 209.877 292.438 212.963 300.154 212.963 300.154 200.617 292.438 200.617",
    fill: "#6c63ff"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.438 138.889 292.438 141.975 295.525 141.975 295.525 148.148 292.438 148.148 292.438 151.235 300.154 151.235 300.154 138.889 292.438 138.889",
    fill: "#6c63ff"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.438 260.802 292.438 263.889 295.525 263.889 295.525 270.062 292.438 270.062 292.438 273.148 300.154 273.148 300.154 260.802 292.438 260.802",
    fill: "#6c63ff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 184.41358,
    y: 320.98765,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 198.30247,
    y: 297.83951,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 184.41358,
    y: 373.45679,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 198.30247,
    y: 336.41975,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.414 300.926 184.414 304.012 187.5 304.012 187.5 310.185 184.414 310.185 184.414 313.272 192.13 313.272 192.13 300.926 184.414 300.926",
    fill: "#6c63ff"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.414 395.062 184.414 398.148 187.5 398.148 187.5 404.321 184.414 404.321 184.414 407.407 192.13 407.407 192.13 395.062 184.414 395.062",
    fill: "#6c63ff"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 269.29012,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 269.29012,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 269.29012,
    y: 359.5679,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.29 100.309 269.29 103.395 272.377 103.395 272.377 109.568 269.29 109.568 269.29 112.654 277.006 112.654 277.006 100.309 269.29 100.309",
    fill: "#6c63ff"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.29 120.37 269.29 123.457 272.377 123.457 272.377 129.63 269.29 129.63 269.29 132.716 277.006 132.716 277.006 120.37 269.29 120.37",
    fill: "#6c63ff"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.29 140.432 269.29 143.519 272.377 143.519 272.377 149.691 269.29 149.691 269.29 152.778 277.006 152.778 277.006 140.432 269.29 140.432",
    fill: "#6c63ff"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 269.29012,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.29 180.556 269.29 183.642 272.377 183.642 272.377 189.815 269.29 189.815 269.29 192.901 277.006 192.901 277.006 180.556 269.29 180.556",
    fill: "#6c63ff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 269.29012,
    y: 240.74074,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.29 220.679 269.29 223.765 272.377 223.765 272.377 229.938 269.29 229.938 269.29 233.025 277.006 233.025 277.006 220.679 269.29 220.679",
    fill: "#6c63ff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 269.29012,
    y: 280.8642,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.29 260.802 269.29 263.889 272.377 263.889 272.377 270.062 269.29 270.062 269.29 273.148 277.006 273.148 277.006 260.802 269.29 260.802",
    fill: "#6c63ff"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 269.29012,
    y: 320.98765,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 269.29012,
    y: 373.45679,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.29 300.926 269.29 304.012 272.377 304.012 272.377 310.185 269.29 310.185 269.29 313.272 277.006 313.272 277.006 300.926 269.29 300.926",
    fill: "#6c63ff"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.29 395.062 269.29 398.148 272.377 398.148 272.377 404.321 269.29 404.321 269.29 407.407 277.006 407.407 277.006 395.062 269.29 395.062",
    fill: "#6c63ff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 306.32716,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 306.32716,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 306.32716,
    y: 359.5679,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.327 100.309 306.327 103.395 309.414 103.395 309.414 109.568 306.327 109.568 306.327 112.654 314.043 112.654 314.043 100.309 306.327 100.309",
    fill: "#6c63ff"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.327 120.37 306.327 123.457 309.414 123.457 309.414 129.63 306.327 129.63 306.327 132.716 314.043 132.716 314.043 120.37 306.327 120.37",
    fill: "#6c63ff"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.327 140.432 306.327 143.519 309.414 143.519 309.414 149.691 306.327 149.691 306.327 152.778 314.043 152.778 314.043 140.432 306.327 140.432",
    fill: "#6c63ff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 306.32716,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.327 180.556 306.327 183.642 309.414 183.642 309.414 189.815 306.327 189.815 306.327 192.901 314.043 192.901 314.043 180.556 306.327 180.556",
    fill: "#6c63ff"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 306.32716,
    y: 240.74074,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.327 220.679 306.327 223.765 309.414 223.765 309.414 229.938 306.327 229.938 306.327 233.025 314.043 233.025 314.043 220.679 306.327 220.679",
    fill: "#6c63ff"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 306.32716,
    y: 280.8642,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.327 260.802 306.327 263.889 309.414 263.889 309.414 270.062 306.327 270.062 306.327 273.148 314.043 273.148 314.043 260.802 306.327 260.802",
    fill: "#6c63ff"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 306.32716,
    y: 320.98765,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 306.32716,
    y: 373.45679,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.327 300.926 306.327 304.012 309.414 304.012 309.414 310.185 306.327 310.185 306.327 313.272 314.043 313.272 314.043 300.926 306.327 300.926",
    fill: "#6c63ff"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.327 395.062 306.327 398.148 309.414 398.148 309.414 404.321 306.327 404.321 306.327 407.407 314.043 407.407 314.043 395.062 306.327 395.062",
    fill: "#6c63ff"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.302 373.457 198.302 376.543 201.389 376.543 201.389 382.716 198.302 382.716 198.302 385.802 206.019 385.802 206.019 373.457 198.302 373.457",
    fill: "#6c63ff"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.302 393.519 198.302 396.605 201.389 396.605 201.389 402.778 198.302 402.778 198.302 405.864 206.019 405.864 206.019 393.519 198.302 393.519",
    fill: "#6c63ff"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.179 160.494 158.179 163.58 161.265 163.58 161.265 169.753 158.179 169.753 158.179 172.84 165.895 172.84 165.895 160.494 158.179 160.494",
    fill: "#6c63ff"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.179 239.198 158.179 242.284 161.265 242.284 161.265 248.457 158.179 248.457 158.179 251.543 165.895 251.543 165.895 239.198 158.179 239.198",
    fill: "#6c63ff"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.179 259.259 158.179 262.346 161.265 262.346 161.265 268.519 158.179 268.519 158.179 271.605 165.895 271.605 165.895 259.259 158.179 259.259",
    fill: "#6c63ff"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.179 299.383 158.179 302.469 161.265 302.469 161.265 308.642 158.179 308.642 158.179 311.728 165.895 311.728 165.895 299.383 158.179 299.383",
    fill: "#6c63ff"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.179 356.481 158.179 359.568 161.265 359.568 161.265 365.741 158.179 365.741 158.179 368.827 165.895 368.827 165.895 356.481 158.179 356.481",
    fill: "#6c63ff"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.179 373.457 158.179 376.543 161.265 376.543 161.265 382.716 158.179 382.716 158.179 385.802 165.895 385.802 165.895 373.457 158.179 373.457",
    fill: "#6c63ff"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 238.42593,
    y: 66.35802,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 238.42593,
    y: 86.41975,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 235.33951,
    y: 108.02469,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 235.33951,
    y: 206.79012,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 235.33951,
    y: 223.76543,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.426 121.914 238.426 125 241.512 125 241.512 131.173 238.426 131.173 238.426 134.259 246.142 134.259 246.142 121.914 238.426 121.914",
    fill: "#6c63ff"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.426 160.494 238.426 163.58 241.512 163.58 241.512 169.753 238.426 169.753 238.426 172.84 246.142 172.84 246.142 160.494 238.426 160.494",
    fill: "#6c63ff"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.426 239.198 238.426 242.284 241.512 242.284 241.512 248.457 238.426 248.457 238.426 251.543 246.142 251.543 246.142 239.198 238.426 239.198",
    fill: "#6c63ff"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 326.38889,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 326.38889,
    y: 220.67901,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 323.30247,
    y: 242.28395,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 323.30247,
    y: 341.04938,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 323.30247,
    y: 358.02469,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.389 256.173 326.389 259.259 329.475 259.259 329.475 265.432 326.389 265.432 326.389 268.519 334.105 268.519 334.105 256.173 326.389 256.173",
    fill: "#6c63ff"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.389 294.753 326.389 297.84 329.475 297.84 329.475 304.012 326.389 304.012 326.389 307.099 334.105 307.099 334.105 294.753 326.389 294.753",
    fill: "#6c63ff"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.389 373.457 326.389 376.543 329.475 376.543 329.475 382.716 326.389 382.716 326.389 385.802 334.105 385.802 334.105 373.457 326.389 373.457",
    fill: "#6c63ff"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 351.08025,
    y: 66.35802,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 377.31481,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2037,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2037,
    y: 100.30864,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 406.6358,
    y: 81.79012,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 406.6358,
    y: 101.85185,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2037,
    y: 140.4321,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 406.6358,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2037,
    y: 236.11111,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 377.31481,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 351.08025,
    y: 86.41975,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 351.08025,
    y: 279.32099,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 351.08025,
    y: 319.44444,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 351.08025,
    y: 339.50617,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 347.99383,
    y: 108.02469,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 389.66049,
    y: 126.54321,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 347.99383,
    y: 206.79012,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 347.99383,
    y: 223.76543,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 389.66049,
    y: 322.53086,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 377.31481,
    y: 359.5679,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.08 121.914 351.08 125 354.167 125 354.167 131.173 351.08 131.173 351.08 134.259 358.796 134.259 358.796 121.914 351.08 121.914",
    fill: "#6c63ff"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.315 100.309 377.315 103.395 380.401 103.395 380.401 109.568 377.315 109.568 377.315 112.654 385.031 112.654 385.031 100.309 377.315 100.309",
    fill: "#6c63ff"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.636 120.37 406.636 123.457 409.722 123.457 409.722 129.63 406.636 129.63 406.636 132.716 414.352 132.716 414.352 120.37 406.636 120.37",
    fill: "#6c63ff"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.636 180.556 406.636 183.642 409.722 183.642 409.722 189.815 406.636 189.815 406.636 192.901 414.352 192.901 414.352 180.556 406.636 180.556",
    fill: "#6c63ff"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.636 200.617 406.636 203.704 409.722 203.704 409.722 209.877 406.636 209.877 406.636 212.963 414.352 212.963 414.352 200.617 406.636 200.617",
    fill: "#6c63ff"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.636 138.889 406.636 141.975 409.722 141.975 409.722 148.148 406.636 148.148 406.636 151.235 414.352 151.235 414.352 138.889 406.636 138.889",
    fill: "#6c63ff"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.204 81.79 391.204 84.877 394.29 84.877 394.29 91.049 391.204 91.049 391.204 94.136 398.92 94.136 398.92 81.79 391.204 81.79",
    fill: "#6c63ff"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2037,
    y: 180.55556,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2037,
    y: 217.59259,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.204 199.074 391.204 202.16 394.29 202.16 394.29 208.333 391.204 208.333 391.204 211.42 398.92 211.42 398.92 199.074 391.204 199.074",
    fill: "#6c63ff"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.315 120.37 377.315 123.457 380.401 123.457 380.401 129.63 377.315 129.63 377.315 132.716 385.031 132.716 385.031 120.37 377.315 120.37",
    fill: "#6c63ff"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.315 140.432 377.315 143.519 380.401 143.519 380.401 149.691 377.315 149.691 377.315 152.778 385.031 152.778 385.031 140.432 377.315 140.432",
    fill: "#6c63ff"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 377.31481,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.315 180.556 377.315 183.642 380.401 183.642 380.401 189.815 377.315 189.815 377.315 192.901 385.031 192.901 385.031 180.556 377.315 180.556",
    fill: "#6c63ff"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 377.31481,
    y: 240.74074,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.315 220.679 377.315 223.765 380.401 223.765 380.401 229.938 377.315 229.938 377.315 233.025 385.031 233.025 385.031 220.679 377.315 220.679",
    fill: "#6c63ff"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 377.31481,
    y: 280.8642,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2037,
    y: 277.77778,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.315 260.802 377.315 263.889 380.401 263.889 380.401 270.062 377.315 270.062 377.315 273.148 385.031 273.148 385.031 260.802 377.315 260.802",
    fill: "#6c63ff"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.636 260.802 406.636 263.889 409.722 263.889 409.722 270.062 406.636 270.062 406.636 273.148 414.352 273.148 414.352 260.802 406.636 260.802",
    fill: "#6c63ff"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 485.33951,
    y: 81.79012,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 485.33951,
    y: 101.85185,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 485.33951,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    points: "485.34 120.37 485.34 123.457 488.426 123.457 488.426 129.63 485.34 129.63 485.34 132.716 493.056 132.716 493.056 120.37 485.34 120.37",
    fill: "#6c63ff"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    points: "485.34 180.556 485.34 183.642 488.426 183.642 488.426 189.815 485.34 189.815 485.34 192.901 493.056 192.901 493.056 180.556 485.34 180.556",
    fill: "#6c63ff"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    points: "485.34 200.617 485.34 203.704 488.426 203.704 488.426 209.877 485.34 209.877 485.34 212.963 493.056 212.963 493.056 200.617 485.34 200.617",
    fill: "#6c63ff"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    points: "485.34 138.889 485.34 141.975 488.426 141.975 488.426 148.148 485.34 148.148 485.34 151.235 493.056 151.235 493.056 138.889 485.34 138.889",
    fill: "#6c63ff"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    points: "485.34 260.802 485.34 263.889 488.426 263.889 488.426 270.062 485.34 270.062 485.34 273.148 493.056 273.148 493.056 260.802 485.34 260.802",
    fill: "#6c63ff"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 377.31481,
    y: 320.98765,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2037,
    y: 297.83951,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 377.31481,
    y: 373.45679,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 391.2037,
    y: 336.41975,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.315 300.926 377.315 304.012 380.401 304.012 380.401 310.185 377.315 310.185 377.315 313.272 385.031 313.272 385.031 300.926 377.315 300.926",
    fill: "#6c63ff"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.315 395.062 377.315 398.148 380.401 398.148 380.401 404.321 377.315 404.321 377.315 407.407 385.031 407.407 385.031 395.062 377.315 395.062",
    fill: "#6c63ff"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 462.19136,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 462.19136,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 462.19136,
    y: 359.5679,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    points: "462.191 100.309 462.191 103.395 465.278 103.395 465.278 109.568 462.191 109.568 462.191 112.654 469.907 112.654 469.907 100.309 462.191 100.309",
    fill: "#6c63ff"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    points: "462.191 120.37 462.191 123.457 465.278 123.457 465.278 129.63 462.191 129.63 462.191 132.716 469.907 132.716 469.907 120.37 462.191 120.37",
    fill: "#6c63ff"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    points: "462.191 140.432 462.191 143.519 465.278 143.519 465.278 149.691 462.191 149.691 462.191 152.778 469.907 152.778 469.907 140.432 462.191 140.432",
    fill: "#6c63ff"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 462.19136,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    points: "462.191 180.556 462.191 183.642 465.278 183.642 465.278 189.815 462.191 189.815 462.191 192.901 469.907 192.901 469.907 180.556 462.191 180.556",
    fill: "#6c63ff"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 462.19136,
    y: 240.74074,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    points: "462.191 220.679 462.191 223.765 465.278 223.765 465.278 229.938 462.191 229.938 462.191 233.025 469.907 233.025 469.907 220.679 462.191 220.679",
    fill: "#6c63ff"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 462.19136,
    y: 280.8642,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    points: "462.191 260.802 462.191 263.889 465.278 263.889 465.278 270.062 462.191 270.062 462.191 273.148 469.907 273.148 469.907 260.802 462.191 260.802",
    fill: "#6c63ff"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 462.19136,
    y: 320.98765,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 462.19136,
    y: 373.45679,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    points: "462.191 300.926 462.191 304.012 465.278 304.012 465.278 310.185 462.191 310.185 462.191 313.272 469.907 313.272 469.907 300.926 462.191 300.926",
    fill: "#6c63ff"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    points: "462.191 395.062 462.191 398.148 465.278 398.148 465.278 404.321 462.191 404.321 462.191 407.407 469.907 407.407 469.907 395.062 462.191 395.062",
    fill: "#6c63ff"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 499.2284,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 499.2284,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 499.2284,
    y: 359.5679,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.228 100.309 499.228 103.395 502.315 103.395 502.315 109.568 499.228 109.568 499.228 112.654 506.944 112.654 506.944 100.309 499.228 100.309",
    fill: "#6c63ff"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.228 120.37 499.228 123.457 502.315 123.457 502.315 129.63 499.228 129.63 499.228 132.716 506.944 132.716 506.944 120.37 499.228 120.37",
    fill: "#6c63ff"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.228 140.432 499.228 143.519 502.315 143.519 502.315 149.691 499.228 149.691 499.228 152.778 506.944 152.778 506.944 140.432 499.228 140.432",
    fill: "#6c63ff"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 499.2284,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.228 180.556 499.228 183.642 502.315 183.642 502.315 189.815 499.228 189.815 499.228 192.901 506.944 192.901 506.944 180.556 499.228 180.556",
    fill: "#6c63ff"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 499.2284,
    y: 240.74074,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.228 220.679 499.228 223.765 502.315 223.765 502.315 229.938 499.228 229.938 499.228 233.025 506.944 233.025 506.944 220.679 499.228 220.679",
    fill: "#6c63ff"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 499.2284,
    y: 280.8642,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.228 260.802 499.228 263.889 502.315 263.889 502.315 270.062 499.228 270.062 499.228 273.148 506.944 273.148 506.944 260.802 499.228 260.802",
    fill: "#6c63ff"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 499.2284,
    y: 320.98765,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 499.2284,
    y: 373.45679,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.228 300.926 499.228 304.012 502.315 304.012 502.315 310.185 499.228 310.185 499.228 313.272 506.944 313.272 506.944 300.926 499.228 300.926",
    fill: "#6c63ff"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.228 395.062 499.228 398.148 502.315 398.148 502.315 404.321 499.228 404.321 499.228 407.407 506.944 407.407 506.944 395.062 499.228 395.062",
    fill: "#6c63ff"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.204 373.457 391.204 376.543 394.29 376.543 394.29 382.716 391.204 382.716 391.204 385.802 398.92 385.802 398.92 373.457 391.204 373.457",
    fill: "#6c63ff"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.204 393.519 391.204 396.605 394.29 396.605 394.29 402.778 391.204 402.778 391.204 405.864 398.92 405.864 398.92 393.519 391.204 393.519",
    fill: "#6c63ff"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.08 160.494 351.08 163.58 354.167 163.58 354.167 169.753 351.08 169.753 351.08 172.84 358.796 172.84 358.796 160.494 351.08 160.494",
    fill: "#6c63ff"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.08 239.198 351.08 242.284 354.167 242.284 354.167 248.457 351.08 248.457 351.08 251.543 358.796 251.543 358.796 239.198 351.08 239.198",
    fill: "#6c63ff"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.08 259.259 351.08 262.346 354.167 262.346 354.167 268.519 351.08 268.519 351.08 271.605 358.796 271.605 358.796 259.259 351.08 259.259",
    fill: "#6c63ff"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.08 299.383 351.08 302.469 354.167 302.469 354.167 308.642 351.08 308.642 351.08 311.728 358.796 311.728 358.796 299.383 351.08 299.383",
    fill: "#6c63ff"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.08 356.481 351.08 359.568 354.167 359.568 354.167 365.741 351.08 365.741 351.08 368.827 358.796 368.827 358.796 356.481 351.08 356.481",
    fill: "#6c63ff"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.08 373.457 351.08 376.543 354.167 376.543 354.167 382.716 351.08 382.716 351.08 385.802 358.796 385.802 358.796 373.457 351.08 373.457",
    fill: "#6c63ff"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 431.32716,
    y: 66.35802,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 431.32716,
    y: 86.41975,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 428.24074,
    y: 108.02469,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 428.24074,
    y: 206.79012,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 428.24074,
    y: 223.76543,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.327 121.914 431.327 125 434.414 125 434.414 131.173 431.327 131.173 431.327 134.259 439.043 134.259 439.043 121.914 431.327 121.914",
    fill: "#6c63ff"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.327 160.494 431.327 163.58 434.414 163.58 434.414 169.753 431.327 169.753 431.327 172.84 439.043 172.84 439.043 160.494 431.327 160.494",
    fill: "#6c63ff"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.327 239.198 431.327 242.284 434.414 242.284 434.414 248.457 431.327 248.457 431.327 251.543 439.043 251.543 439.043 239.198 431.327 239.198",
    fill: "#6c63ff"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 519.29012,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 519.29012,
    y: 220.67901,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 516.2037,
    y: 242.28395,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 516.2037,
    y: 341.04938,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 516.2037,
    y: 358.02469,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    points: "519.29 256.173 519.29 259.259 522.377 259.259 522.377 265.432 519.29 265.432 519.29 268.519 527.006 268.519 527.006 256.173 519.29 256.173",
    fill: "#6c63ff"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    points: "519.29 294.753 519.29 297.84 522.377 297.84 522.377 304.012 519.29 304.012 519.29 307.099 527.006 307.099 527.006 294.753 519.29 294.753",
    fill: "#6c63ff"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    points: "519.29 373.457 519.29 376.543 522.377 376.543 522.377 382.716 519.29 382.716 519.29 385.802 527.006 385.802 527.006 373.457 519.29 373.457",
    fill: "#6c63ff"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 543.98148,
    y: 66.35802,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 570.21605,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 584.10494,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 584.10494,
    y: 100.30864,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 599.53704,
    y: 81.79012,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 599.53704,
    y: 101.85185,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 584.10494,
    y: 140.4321,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 599.53704,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 584.10494,
    y: 236.11111,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 570.21605,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 543.98148,
    y: 86.41975,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 543.98148,
    y: 279.32099,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 543.98148,
    y: 319.44444,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 543.98148,
    y: 339.50617,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 540.89506,
    y: 108.02469,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 582.56173,
    y: 126.54321,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 540.89506,
    y: 206.79012,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 540.89506,
    y: 223.76543,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 582.56173,
    y: 322.53086,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 570.21605,
    y: 359.5679,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.981 121.914 543.981 125 547.068 125 547.068 131.173 543.981 131.173 543.981 134.259 551.698 134.259 551.698 121.914 543.981 121.914",
    fill: "#6c63ff"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.216 100.309 570.216 103.395 573.302 103.395 573.302 109.568 570.216 109.568 570.216 112.654 577.932 112.654 577.932 100.309 570.216 100.309",
    fill: "#6c63ff"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.537 120.37 599.537 123.457 602.623 123.457 602.623 129.63 599.537 129.63 599.537 132.716 607.253 132.716 607.253 120.37 599.537 120.37",
    fill: "#6c63ff"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.537 180.556 599.537 183.642 602.623 183.642 602.623 189.815 599.537 189.815 599.537 192.901 607.253 192.901 607.253 180.556 599.537 180.556",
    fill: "#6c63ff"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.537 200.617 599.537 203.704 602.623 203.704 602.623 209.877 599.537 209.877 599.537 212.963 607.253 212.963 607.253 200.617 599.537 200.617",
    fill: "#6c63ff"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.537 138.889 599.537 141.975 602.623 141.975 602.623 148.148 599.537 148.148 599.537 151.235 607.253 151.235 607.253 138.889 599.537 138.889",
    fill: "#6c63ff"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    points: "584.105 81.79 584.105 84.877 587.191 84.877 587.191 91.049 584.105 91.049 584.105 94.136 591.821 94.136 591.821 81.79 584.105 81.79",
    fill: "#6c63ff"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 584.10494,
    y: 180.55556,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 584.10494,
    y: 217.59259,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    points: "584.105 199.074 584.105 202.16 587.191 202.16 587.191 208.333 584.105 208.333 584.105 211.42 591.821 211.42 591.821 199.074 584.105 199.074",
    fill: "#6c63ff"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.216 120.37 570.216 123.457 573.302 123.457 573.302 129.63 570.216 129.63 570.216 132.716 577.932 132.716 577.932 120.37 570.216 120.37",
    fill: "#6c63ff"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.216 140.432 570.216 143.519 573.302 143.519 573.302 149.691 570.216 149.691 570.216 152.778 577.932 152.778 577.932 140.432 570.216 140.432",
    fill: "#6c63ff"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 570.21605,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.216 180.556 570.216 183.642 573.302 183.642 573.302 189.815 570.216 189.815 570.216 192.901 577.932 192.901 577.932 180.556 570.216 180.556",
    fill: "#6c63ff"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 570.21605,
    y: 240.74074,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.216 220.679 570.216 223.765 573.302 223.765 573.302 229.938 570.216 229.938 570.216 233.025 577.932 233.025 577.932 220.679 570.216 220.679",
    fill: "#6c63ff"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 570.21605,
    y: 280.8642,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 584.10494,
    y: 277.77778,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.216 260.802 570.216 263.889 573.302 263.889 573.302 270.062 570.216 270.062 570.216 273.148 577.932 273.148 577.932 260.802 570.216 260.802",
    fill: "#6c63ff"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.537 260.802 599.537 263.889 602.623 263.889 602.623 270.062 599.537 270.062 599.537 273.148 607.253 273.148 607.253 260.802 599.537 260.802",
    fill: "#6c63ff"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 678.24074,
    y: 81.79012,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 678.24074,
    y: 101.85185,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 678.24074,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    points: "678.241 120.37 678.241 123.457 681.327 123.457 681.327 129.63 678.241 129.63 678.241 132.716 685.957 132.716 685.957 120.37 678.241 120.37",
    fill: "#6c63ff"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    points: "678.241 180.556 678.241 183.642 681.327 183.642 681.327 189.815 678.241 189.815 678.241 192.901 685.957 192.901 685.957 180.556 678.241 180.556",
    fill: "#6c63ff"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    points: "678.241 200.617 678.241 203.704 681.327 203.704 681.327 209.877 678.241 209.877 678.241 212.963 685.957 212.963 685.957 200.617 678.241 200.617",
    fill: "#6c63ff"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    points: "678.241 138.889 678.241 141.975 681.327 141.975 681.327 148.148 678.241 148.148 678.241 151.235 685.957 151.235 685.957 138.889 678.241 138.889",
    fill: "#6c63ff"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    points: "678.241 260.802 678.241 263.889 681.327 263.889 681.327 270.062 678.241 270.062 678.241 273.148 685.957 273.148 685.957 260.802 678.241 260.802",
    fill: "#6c63ff"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 570.21605,
    y: 320.98765,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 584.10494,
    y: 297.83951,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 570.21605,
    y: 373.45679,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 584.10494,
    y: 336.41975,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.216 300.926 570.216 304.012 573.302 304.012 573.302 310.185 570.216 310.185 570.216 313.272 577.932 313.272 577.932 300.926 570.216 300.926",
    fill: "#6c63ff"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.216 395.062 570.216 398.148 573.302 398.148 573.302 404.321 570.216 404.321 570.216 407.407 577.932 407.407 577.932 395.062 570.216 395.062",
    fill: "#6c63ff"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 655.09259,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 655.09259,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 655.09259,
    y: 359.5679,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    points: "655.093 100.309 655.093 103.395 658.179 103.395 658.179 109.568 655.093 109.568 655.093 112.654 662.809 112.654 662.809 100.309 655.093 100.309",
    fill: "#6c63ff"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    points: "655.093 120.37 655.093 123.457 658.179 123.457 658.179 129.63 655.093 129.63 655.093 132.716 662.809 132.716 662.809 120.37 655.093 120.37",
    fill: "#6c63ff"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    points: "655.093 140.432 655.093 143.519 658.179 143.519 658.179 149.691 655.093 149.691 655.093 152.778 662.809 152.778 662.809 140.432 655.093 140.432",
    fill: "#6c63ff"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 655.09259,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    points: "655.093 180.556 655.093 183.642 658.179 183.642 658.179 189.815 655.093 189.815 655.093 192.901 662.809 192.901 662.809 180.556 655.093 180.556",
    fill: "#6c63ff"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 655.09259,
    y: 240.74074,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    points: "655.093 220.679 655.093 223.765 658.179 223.765 658.179 229.938 655.093 229.938 655.093 233.025 662.809 233.025 662.809 220.679 655.093 220.679",
    fill: "#6c63ff"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 655.09259,
    y: 280.8642,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    points: "655.093 260.802 655.093 263.889 658.179 263.889 658.179 270.062 655.093 270.062 655.093 273.148 662.809 273.148 662.809 260.802 655.093 260.802",
    fill: "#6c63ff"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 655.09259,
    y: 320.98765,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 655.09259,
    y: 373.45679,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    points: "655.093 300.926 655.093 304.012 658.179 304.012 658.179 310.185 655.093 310.185 655.093 313.272 662.809 313.272 662.809 300.926 655.093 300.926",
    fill: "#6c63ff"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    points: "655.093 395.062 655.093 398.148 658.179 398.148 658.179 404.321 655.093 404.321 655.093 407.407 662.809 407.407 662.809 395.062 655.093 395.062",
    fill: "#6c63ff"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 692.12963,
    y: 63.2716,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 692.12963,
    y: 160.49383,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 692.12963,
    y: 359.5679,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    points: "692.13 100.309 692.13 103.395 695.216 103.395 695.216 109.568 692.13 109.568 692.13 112.654 699.846 112.654 699.846 100.309 692.13 100.309",
    fill: "#6c63ff"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    points: "692.13 120.37 692.13 123.457 695.216 123.457 695.216 129.63 692.13 129.63 692.13 132.716 699.846 132.716 699.846 120.37 692.13 120.37",
    fill: "#6c63ff"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    points: "692.13 140.432 692.13 143.519 695.216 143.519 695.216 149.691 692.13 149.691 692.13 152.778 699.846 152.778 699.846 140.432 692.13 140.432",
    fill: "#6c63ff"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 692.12963,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    points: "692.13 180.556 692.13 183.642 695.216 183.642 695.216 189.815 692.13 189.815 692.13 192.901 699.846 192.901 699.846 180.556 692.13 180.556",
    fill: "#6c63ff"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 692.12963,
    y: 240.74074,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    points: "692.13 220.679 692.13 223.765 695.216 223.765 695.216 229.938 692.13 229.938 692.13 233.025 699.846 233.025 699.846 220.679 692.13 220.679",
    fill: "#6c63ff"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 692.12963,
    y: 280.8642,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    points: "692.13 260.802 692.13 263.889 695.216 263.889 695.216 270.062 692.13 270.062 692.13 273.148 699.846 273.148 699.846 260.802 692.13 260.802",
    fill: "#6c63ff"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 692.12963,
    y: 320.98765,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 692.12963,
    y: 373.45679,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    points: "692.13 300.926 692.13 304.012 695.216 304.012 695.216 310.185 692.13 310.185 692.13 313.272 699.846 313.272 699.846 300.926 692.13 300.926",
    fill: "#6c63ff"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    points: "692.13 395.062 692.13 398.148 695.216 398.148 695.216 404.321 692.13 404.321 692.13 407.407 699.846 407.407 699.846 395.062 692.13 395.062",
    fill: "#6c63ff"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    points: "584.105 373.457 584.105 376.543 587.191 376.543 587.191 382.716 584.105 382.716 584.105 385.802 591.821 385.802 591.821 373.457 584.105 373.457",
    fill: "#6c63ff"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    points: "584.105 393.519 584.105 396.605 587.191 396.605 587.191 402.778 584.105 402.778 584.105 405.864 591.821 405.864 591.821 393.519 584.105 393.519",
    fill: "#6c63ff"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.981 160.494 543.981 163.58 547.068 163.58 547.068 169.753 543.981 169.753 543.981 172.84 551.698 172.84 551.698 160.494 543.981 160.494",
    fill: "#6c63ff"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.981 239.198 543.981 242.284 547.068 242.284 547.068 248.457 543.981 248.457 543.981 251.543 551.698 251.543 551.698 239.198 543.981 239.198",
    fill: "#6c63ff"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.981 259.259 543.981 262.346 547.068 262.346 547.068 268.519 543.981 268.519 543.981 271.605 551.698 271.605 551.698 259.259 543.981 259.259",
    fill: "#6c63ff"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.981 299.383 543.981 302.469 547.068 302.469 547.068 308.642 543.981 308.642 543.981 311.728 551.698 311.728 551.698 299.383 543.981 299.383",
    fill: "#6c63ff"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.981 356.481 543.981 359.568 547.068 359.568 547.068 365.741 543.981 365.741 543.981 368.827 551.698 368.827 551.698 356.481 543.981 356.481",
    fill: "#6c63ff"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.981 373.457 543.981 376.543 547.068 376.543 547.068 382.716 543.981 382.716 543.981 385.802 551.698 385.802 551.698 373.457 543.981 373.457",
    fill: "#6c63ff"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 624.2284,
    y: 66.35802,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 624.2284,
    y: 86.41975,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 621.14198,
    y: 108.02469,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 621.14198,
    y: 206.79012,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 621.14198,
    y: 223.76543,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    points: "624.228 121.914 624.228 125 627.315 125 627.315 131.173 624.228 131.173 624.228 134.259 631.944 134.259 631.944 121.914 624.228 121.914",
    fill: "#6c63ff"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    points: "624.228 160.494 624.228 163.58 627.315 163.58 627.315 169.753 624.228 169.753 624.228 172.84 631.944 172.84 631.944 160.494 624.228 160.494",
    fill: "#6c63ff"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    points: "624.228 239.198 624.228 242.284 627.315 242.284 627.315 248.457 624.228 248.457 624.228 251.543 631.944 251.543 631.944 239.198 624.228 239.198",
    fill: "#6c63ff"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 712.19136,
    y: 200.61728,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 712.19136,
    y: 220.67901,
    width: 7.71605,
    height: 12.34568,
    fill: "#6c63ff"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 709.10494,
    y: 242.28395,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 709.10494,
    y: 341.04938,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 709.10494,
    y: 358.02469,
    width: 10.80247,
    height: 1.54321,
    fill: "#6c63ff"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    points: "712.191 256.173 712.191 259.259 715.278 259.259 715.278 265.432 712.191 265.432 712.191 268.519 719.907 268.519 719.907 256.173 712.191 256.173",
    fill: "#6c63ff"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    points: "712.191 294.753 712.191 297.84 715.278 297.84 715.278 304.012 712.191 304.012 712.191 307.099 719.907 307.099 719.907 294.753 712.191 294.753",
    fill: "#6c63ff"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    points: "712.191 373.457 712.191 376.543 715.278 376.543 715.278 382.716 712.191 382.716 712.191 385.802 719.907 385.802 719.907 373.457 712.191 373.457",
    fill: "#6c63ff"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 214.43464,
    y: 706.53418,
    width: 827.6044,
    height: 2.55433,
    fill: "#2f2e41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.48048,499.79525v52l7,32s-1,20,0,26-1,16-7,16-9,15-9,15-2,6-7,7-5,0-5,0l-4,10-83,55,16,40s25-9,27-12,19,4,19-3,3-25,9-26,56-24,56-24,26-29,28-40,11-42,11-42l25,42v84l-4,45,44-6s-4-28,0-32,10-52,6-58,2-33,0-37-1-33-6-41-35-90-35-90Z",
    transform: "translate(-78.98048 -95.45574)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M549.48048,774.79525s-15,25-5,28,29,0,31,0,38,1,38,1,24-5,24-12-15-7-20-8-36-13-36-13Z",
    transform: "translate(-78.98048 -95.45574)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.073,713.92342s-28.90243-3.82749-27.68058,6.54107,11.52662,26.61084,12.32156,28.44607c.53837,1.24292,6.85438,16.97832,10.87521,27.00587a58.47551,58.47551,0,0,0,12.83544,19.65205c3.93123,3.92912,8.216,7.07932,11.02623,5.86207,6.4233-2.78229.46126-16.54652-.60847-21.53206s-2.37991-38.20126-2.37991-38.20126Z",
    transform: "translate(-78.98048 -95.45574)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M561.98048,334.29525l32-74s-3-7-10-6c0,0-9.5-24.5-27.5-24.5,0,0-27-15-35,0,0,0-17,15-16,29s2,24,2,24-16,2-13,10,4,8,0,11l-4,3s-83,75-37,185l4,17v16s101,1,101,0-2-7,2-11,4-10,4-10-4-20-2-26,3-32-1-38-2-54-2-54l9-17-3-10-3-10Z",
    transform: "translate(-78.98048 -95.45574)",
    fill: "#8985a8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M553.48048,534.79525s-12-33-11-39-2-18-2-18l-4-81s17-72-21-84c0,0-9.61547,4.19556-17.49389,17.697-7.79077,3.47015-17.24439,12.25226-19.50611,34.303-4,39,14,139,23,156s15,29,15,29l9.4065-4.18066c.38843.7705.5935,1.18066.5935,1.18066Z",
    transform: "translate(-78.98048 -95.45574)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 226.83951,
    r: 3,
    fill: "#f2f2f2"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 479,
    y: 226.83951,
    width: 2,
    height: 47,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M522.98048,538.29525l8,17s18-6,18-9-8-16-8-16Z",
    transform: "translate(-78.98048 -95.45574)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M511.48048,312.79525s-23,10-27,49,14,139,23,156,15,29,15,29l27-12s-12-33-11-39-2-18-2-18l-4-81S549.48048,324.79525,511.48048,312.79525Z",
    transform: "translate(-78.98048 -95.45574)",
    fill: "#8985a8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberSecurity);
export default __webpack_public_path__ + "static/media/Cyber_Security.b68792fe9386e304f1888a2e72c2b4be.svg";
export { ForwardRef as ReactComponent };